export const primitive = {
  borderRadius: {
    none: '0',
    xs: '2px',
    sm: '4px',
    md: '6px',
    lg: '8px',
    xl: '12px',
  },
  colors: {
    main: '#184c5c',
    white: '#ffffff',
    gray: '#757575',
    transparent: 'rgba(0, 0, 0, 0)',
    hover: '#184c5ceb',
    black: '#000000',
    calypso: '#3e7c94',
  },
};
